module.exports = __webpack_public_path__ + "static/img/smartstation52.1a449202.png";